
'use strict'

import WhatWeDoAreas from "./WhatWeDoAreas";
import WhatWeDoClients from "./WhatWeDoClients";

class WhatWeDo{
    constructor(){
        this._areas = new WhatWeDoAreas();
        this._clients = new WhatWeDoClients();
    }
}

export default WhatWeDo;
